import React, {Fragment} from 'react'
import {ConfirmationDialog} from 'common/styleguide/ConfirmationDialog'

export const ARCHIVE_ROUTES_DIALOG = 'ARCHIVE_ROUTES_DIALOG'
export const UNARCHIVE_ROUTES_DIALOG = 'UNARCHIVE_ROUTES_DIALOG'

const DELAY_WARNING = <p>Note: This will take up to a minute to process.</p>

class ArchiveDialog extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      pending: false,
      error: false
    }
  }

  onConfirm = () => {
    const {onConfirm, onRequestClose} = this.props
    this.setState({pending: true})
    onConfirm()
      .then(onRequestClose)
      .catch(() => this.setState({pending: false, error: true}))
  }

  render () {
    const {
      onRequestClose,
      confirmMessage,
      errorMessage,
      confirmText,
      title
    } = this.props
    const {
      pending,
      error
    } = this.state

    return (
      <ConfirmationDialog
        primary danger
        maxWidth='600px'
        onRequestClose={onRequestClose}
        onCancel={onRequestClose}
        onConfirm={this.onConfirm}
        confirmPending={pending}
        confirmText={confirmText}
        title={title}>
        {confirmMessage}
        {error && <div className={errorMessage}>
          {errorMessage}
        </div>}
      </ConfirmationDialog>
    )
  }
}

const toggleArchiveRouteComponent = isArchive => ({route, ...props}) => {
  return <ArchiveDialog
    title={<Fragment>{isArchive ? 'Archive' : 'Unarchive'} <strong>{route.name}</strong>?</Fragment>}
    confirmText={isArchive ? 'Archive route' : 'Unarchive route'}
    confirmMessage={<Fragment><p>
      Are you sure you want to {isArchive ? 'archive' : 'unarchive'} your route, <strong>{route.name}</strong>?
    </p>{DELAY_WARNING}</Fragment>}
    errorMessage={`Oops, we encountered an error while ${isArchive ? 'archiving' : 'unarchiving'} this route. Please try again.`}
    {...props} />
}

const ArchiveRoute = toggleArchiveRouteComponent(true)
const UnarchiveRoute = toggleArchiveRouteComponent(false)

const toggleArchiveRoutesComponent = isArchive => ({routes, ...props}) => {
  if (routes.length === 1) {
    const Component = isArchive ? ArchiveRoute : UnarchiveRoute
    return <Component route={routes[0]} {...props} />
  } else {
    const countStr = `${routes.length} routes`

    return (<ArchiveDialog
      title={<Fragment>{isArchive ? 'Archive' : 'Unarchive'} <strong>{countStr}</strong>?</Fragment>}
      confirmMessage={<Fragment><p>
        Are you sure you want to {isArchive ? 'archive' : 'unarchive'} <strong>{countStr}</strong>?
      </p>{DELAY_WARNING}</Fragment>}
      confirmText={<Fragment>{isArchive ? 'Archive' : 'Unarchive'} {countStr}</Fragment>}
      errorMessage={`Oops, we encountered an error while ${isArchive ? 'archiving' : 'unarchiving'} these routes. Please try again.`}
      {...props}
    />)
  }
}

export const ArchiveRoutes = toggleArchiveRoutesComponent(true)
export const UnarchiveRoutes = toggleArchiveRoutesComponent(false)
